import React from 'react'
import { useHistory } from 'react-router-dom'
import { SurfacePalette, type, radius, accentSoft } from '../../tokens'

interface Props {
  palette: SurfacePalette
  businessID: number
  packetID: number
}

/**
 * Links out of the packet to the review surface, where ads are actually approved
 * and rejected. Rendered by both the editor's Creative section and the deck's
 * Creative slide — one link-out card living in both modes is the same shape
 * `MarketingMilkHandoffCard` already ships in.
 *
 * `history.push` rather than an anchor: the deck and the review page are the same
 * app, and a full page load would drop the packet queries the review page then
 * immediately refetches.
 */
export const CreativeReviewHandoffCard = ({ palette, businessID, packetID }: Props) => {
  const history = useHistory()

  return (
    <div
      style={{
        marginTop: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '14px 16px',
        border: `1px solid ${palette.hairline}`,
        borderRadius: radius.md,
        background: accentSoft,
        fontFamily: type.family.sans,
      }}
    >
      <div>
        <div
          style={{
            fontSize: type.size.bodyLg,
            fontWeight: type.weight.semibold,
            color: palette.text,
          }}
        >
          Review the ads
        </div>
        <div style={{ marginTop: 2, fontSize: type.size.body, color: palette.textMuted }}>
          Every ad in this sprint, one at a time, with approve and reject on each.
        </div>
      </div>
      <button
        type="button"
        onClick={() => history.push(`/${businessID}/sprint-packets/${packetID}/review`)}
        style={{
          padding: '8px 14px',
          borderRadius: radius.sm,
          fontFamily: type.family.sans,
          fontSize: type.size.body,
          fontWeight: type.weight.medium,
          letterSpacing: '0.02em',
          border: 'none',
          cursor: 'pointer',
          background: palette.accent,
          color: palette.accentInk,
          whiteSpace: 'nowrap',
        }}
      >
        Launch Creative Review →
      </button>
    </div>
  )
}
